import React, { useMemo } from 'react';

import { ia } from 'lib/helpers/utility';

import TableNoData from './components/TableNoData';
import TableGfeContent from './components/TableGfe/TableGfeContent';
import TableConfirmedContent from './components/TableConfirmedContent';

const groupStatusComponents = {
  GFE: TableGfeContent,
  Confirmed: TableConfirmedContent
};

const InvoiceTable = ({
  columnDefs,
  rowData,
  noDataText = 'No items to show',
  footer,
  invoiceId,
  setRowData,
  preview,
  openModal,
  invoice,
  CustomRowHeader,
  checkin
}) => {
  const visibleCols = useMemo(() => columnDefs.filter((col) => !col.hide), [columnDefs]);

  return (
    <table className="h-fit w-full max-w-full table-fixed border-collapse">
      <tbody>
        {ia(rowData) ? (
          rowData
            .sort((a, b) => {
              if (a.statusName === 'Confirmed' && b.statusName !== 'Confirmed') return -1;
              if (a.statusName !== 'Confirmed' && b.statusName === 'Confirmed') return 1;
              return 0;
            })
            .map((statusGroup) => {
              const Component = groupStatusComponents[statusGroup.statusName];
              const variant = statusGroup.statusName === 'GFE' ? 'primary' : 'neutral';
              return (
                <React.Fragment key={statusGroup.statusName}>
                  <tr className="h-4" aria-hidden="true">
                    <td colSpan={visibleCols.length} />
                  </tr>
                  <Component
                    key={statusGroup.statusName}
                    visibleCols={visibleCols}
                    statusGroup={statusGroup}
                    invoices={Object.entries(statusGroup.invoices)}
                    setRowData={setRowData}
                    invoiceId={invoiceId}
                    preview={preview}
                    openModal={openModal}
                    invoice={invoice}
                    CustomRowHeader={CustomRowHeader}
                    checkin={checkin}
                    footer={footer}
                    rowData={rowData}
                    variant={variant}
                  />
                </React.Fragment>
              );
            })
        ) : (
          <TableNoData columnDefs={visibleCols} noDataText={noDataText} />
        )}
      </tbody>
    </table>
  );
};

export default InvoiceTable;
